import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.HostV2}/${EndPoint.Department}`;

export async function getDepartment() {
  return await Client.get(`${endpoint}`, {}, true);
}

export async function patchDepartment(id, data) {
  return await Client.patch(`${endpoint}/${id}`, data, true);
}

export async function deleteDepartment(id) {
  return await Client.delete(`${endpoint}/${id}`, {}, true);
}

export async function createDepartment(data) {
  return await Client.post(`${endpoint}`, data, true);
}
